var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgYoutubeRed = function SvgYoutubeRed(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M19.558 5.527a2.51 2.51 0 0 0-1.77-1.77c-1.552-.424-7.798-.424-7.798-.424s-6.247.013-7.799.436a2.51 2.51 0 0 0-1.77 1.77c-.47 2.758-.651 6.96.013 9.608a2.51 2.51 0 0 0 1.77 1.77c1.552.423 7.799.423 7.799.423s6.246 0 7.798-.423a2.51 2.51 0 0 0 1.77-1.77c.495-2.762.648-6.961-.013-9.62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m8.002 13.338 5.182-3.001-5.182-3.002z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgYoutubeRed);
export { ForwardRef as ReactComponent };